import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ITransactionsResponse,
  ITrxStatus,
  ITrxType,
} from '@http/interfaces/transaction';
import { ITransactionsRequest } from '@http/interfaces/transaction.http-interface';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  canCancelTransaction = true;
  partnersTransactions = false;

  constructor(
    private http: HttpClient
  ) {
  }

  getTransactions(
    filter: TransactionsFilter = {},
    page = 1,
    per_page = 10,
    desc: 0 | 1 = 0,
    lang: string
  ): Observable<ITransactionsResponse> {
    const data: ITransactionsRequest = {
      tz_offset: 0,
      lang,
      desc,
      page,
      per_page,
      ...filter,
    };

    return this.http.post<ITransactionsResponse>('get_transactions_list', data)
  }

  getTransactionsCsvList(
    filter: TransactionsFilter = {},
    page = 1,
    per_page = 10,
    desc: 0 | 1 = 0,
    lang: string
  ): Observable<any> {
    const data: any = {
      tz_offset: 0,
      page,
      per_page,
      desc,
      lang,
      ...filter,
      csv: 1,
    };
    return this.http.post<ITransactionsResponse>(
      'get_transactions_list',
      data,
      { responseType: 'blob' as 'json' }
    )
  }

  cancelTransaction(trxid: string) {
    const data: any = {
      trxid,
    };
    return this.http.post<ITransactionsResponse>('cancel_withdrawal', data)
  }
}

export interface TransactionsFilter {
  accounts_ids?: string;
  coin_id?: number;
  from_date?: string;
  to_date?: string;
  trx_type_id?: ITrxType;
  status_id?: ITrxStatus;
  account_type?: string;
  export?: 'csv' | 'pdf';
  is_affiliate?: 0 | 1;
  balances_user?: 0 | 1;
  code_user?: string;
  status_user?: 'new' | 'confirmed' | 'checking' | 'verified' | 'deleted';
  code_type?: 'promo' | 'affiliate' | 'referral' | 'all' | 'nocode';
  country_user?: string;
}
